import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import styles from './badges-levels.styl'
import { LEVELS } from 'constants/enums'
import { Link } from 'react-router-dom'
import config from 'config'

export default class BadgesLevels extends Component {
  static propTypes = {
    activeOnly: PropTypes.bool,
    hasGold: PropTypes.bool,
    hasSilver: PropTypes.bool,
    hasBronze: PropTypes.bool,
    single: PropTypes.bool,
    small: PropTypes.bool,
    overview: PropTypes.bool,
    levels: PropTypes.array,
    participantId: PropTypes.number

  }

  static defaultProps = {
    activeOnly: false,
    overview: false
  }

  getBadge (index, single, item, isActiveClass, small, participantId, awardTab) {
    if (awardTab || single || this.props.overview) {

      return (<Link to={`${config.publicPath}/participants/${participantId}/${awardTab}`} key={index}>
        <span
          className={`${styles.badge} ${small && styles.small} ${
            styles[`badge-${index + 1}`]
          } ${isActiveClass}`}
        >
          {small || <FormattedMessage id={item.intlKey} defaultMessage={item.label} />}
        </span>
      </Link>)

    } else {
      return (
        <span
          key={index}
          className={`${styles.badge} ${small && styles.small} ${
            styles[`badge-${index + 1}`]
          } ${isActiveClass}`}
        >
          {small || <FormattedMessage id={item.intlKey} defaultMessage={item.label} />}
        </span>
      )
    }
  }

  render () {
    const {
      levels,
      activeOnly,
      single,
      small,
      hasGold,
      hasSilver,
      hasBronze,
      participantId,
      overview
    } = this.props
    let template = null
    const visibilityClass = activeOnly ? styles.hidden : styles.disabled

    template = LEVELS.list.map((item, index) => {
      const activeLevels = {}

      if (levels) {
        for (const level of levels) {
          activeLevels[get(level, 'awardLevel.value')] =
            get(level, 'awardLevel.value') === item.key
        }
      }

      let isActiveClass = !activeLevels[item.key] ? visibilityClass : ''
      let awardTab = ''

      // performance optimization for participants call
      if (((single || overview) && item.key === LEVELS.GOLD.value) || (item.key === LEVELS.GOLD.value && hasGold)) {
        if(!overview){isActiveClass = ''}
        awardTab = 'gold-level'
      }
      if (((single || overview) && item.key === LEVELS.SILVER.value) || (item.key === LEVELS.SILVER.value && hasSilver)) {
        if(!overview){isActiveClass = ''}
        awardTab = 'silver-level'
      }
      if (((single || overview) && item.key === LEVELS.BRONZE.value) || (item.key === LEVELS.BRONZE.value && hasBronze)) {
        if(!overview){isActiveClass = ''}
        awardTab = 'bronze-level'
      }

      if (single && !activeLevels[item.key]) {
        return null
      }

      return (
        this.getBadge(index, single, item, isActiveClass, small, participantId, awardTab)
      )
    })

    return <div className={styles.badges}>{template}</div>
  }
}
